import { render, staticRenderFns } from "./LabelSIcon.vue?vue&type=template&id=57665e61&"
import script from "./LabelSIcon.vue?vue&type=script&lang=js&"
export * from "./LabelSIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports